<app-navbar
  [currentUser]="profileInfo$ | async"
  (logedout)="logout()"
  [rightStateSidebar]="_loadComponentService.rightSidebarSubject.getValue()"
  (rightSidebarChange)="toggleRightSidebar($event)"></app-navbar>
<mat-divider></mat-divider>
<mat-sidenav-container class="drawer-container" [hasBackdrop]="true">
  <mat-sidenav
    #rightSidebar
    class="right-drawer"
    mode="over"
    [opened]="isRightOpen$ | async"
    (closedStart)="toggleRightSidebar(false)"
    position="end">
    <app-sidebar (rightSidebarChange)="toggleRightSidebar($event)" (logedout)="logout()"></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="h-100">
      <div *ngIf="(spiner$ | async) || false" class="spinner">
        <mat-progress-spinner class="loading-indicator" mode="indeterminate" diameter="64"> </mat-progress-spinner>
      </div>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
